import { environment } from '../../../../environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

declare var $ : any;

@Component({
  selector: 'app-forceresetmodal',
  templateUrl: './forceresetmodal.component.html',
  styleUrls: ['./forceresetmodal.component.css']
})
export class ForceResetModalComponent implements OnInit {

  @Input() instanceId: string;
  username = "";
  isPasswordChangeError = false;

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.username = "";
    this.isPasswordChangeError = false;
  }

  show(username){
    this.username = username;
    let modal = $(`#${this.instanceId}`);
    modal.addClass('show');
    modal.css({'display':'block'});
  
    $('.modal-dialog').draggable({
      handle: ".modalHeader"
    });

    this.centerModal();
  }
  
  onResize(event) {
    this.centerModal();
  }

  centerModal()
  {
    $('.modal-dialog')[0].style.top = "0px";
    if (window.innerWidth < 500)
    {
      $('.modal-dialog')[0].style.left = 0;
    }
    else
    {
      $('.modal-dialog')[0].style.left = ((window.innerWidth - 375) / 2) + "px";
    }
  }

  OnSubmit(password, newPassword)
  {
    this.isPasswordChangeError = false;
    this.authService.setPassword(this.username, password, newPassword)
        .subscribe(
          (data:any) => {
            $('#btnResetPw').removeClass('btn-info');
            $('#btnResetPw').removeClass('btn-danger');
            $('#btnResetPw').addClass('btn-success');
            setTimeout(
              ()=>{this.doLogin(data);}, 1000);
          },
          (err: HttpErrorResponse) => {
            console.log(err);
            $('#btnResetPw').removeClass('btn-info');
            $('#btnResetPw').addClass('btn-danger');
            this.isPasswordChangeError = true;
          }
        );
  }

  doLogin(data){
   
    let accountUser = {
      'userName': data.userName,
      'fullName': data.fullName,
      'accountName':data.accountName,
      'isLabAdmin': data.isLabAdmin,
      'reportDelivery': data.reportDelivery
    };

    localStorage.setItem('accountUser', JSON.stringify(accountUser));
    let isLoggedIn = this.authService.isLoggedIn.subscribe(); //Need this to force AuthService to refresh its isLoggedIn state.
    this.router.navigate(['/reporting/testreportlist']);
  }
}
